const FormSubTitle: React.FC = ({ children }) => <p className="form-sub-title">{children}</p>;

export default FormSubTitle;
